import React from 'react';
import { Container as MUIContainer, Grid, Box } from '@material-ui/core';
import PropTypes from 'prop-types';

const Content = ({ children, md, alignMiddle, withSidebar, component }) => {
  return withSidebar ? (
    <Box p={{ xs: 2, md: 4 }} mt={{ xs: 7, md: 8 }} ml={{ sm: 36 }}>
      {/* adjustment for sidebar and header */}
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12} md={md}>
          {children}
        </Grid>
      </Grid>
    </Box>
  ) : (
    <MUIContainer component={component}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        style={{
          minHeight: alignMiddle ? 'calc(100vh - 256px)' : '100%',
        }}
      >
        <Grid item xs={12} md={md}>
          {children}
        </Grid>
      </Grid>
    </MUIContainer>
  );
};

Content.defaultProps = {
  md: 9,
  alignMiddle: false,
  withSidebar: false,
  component: 'div',
};

Content.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  md: PropTypes.number,
  alignMiddle: PropTypes.bool,
  withSidebar: PropTypes.bool,
  component: PropTypes.string,
};

export default Content;
